module.exports = __webpack_public_path__ + "static/media/ATMA-SPHERE GEM 5 AMPLIFIER.6db6f2a5.png";